import Cookies from "js-cookie";
import api from "./index";
import { GetApiResponse } from "../types/api";
import { AreaOfInterest, AreaOfInterestPreview } from "../types/areaOfInterest";

const accessToken = () => Cookies.get("accessToken");

export const getAreaOfInterestsService = async ({
  country,
}: {
  country: string;
}): Promise<GetApiResponse<AreaOfInterest[]>> => {
  try {
    const response = await api.get<GetApiResponse<AreaOfInterest[]>>(
      "/AreaOfInterest",
      {
        headers: {
          ...(accessToken()
            ? { Authorization: `Bearer ${accessToken()}` }
            : {}),
        },
        params: {
          country,
        },
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getAreaOfInterestDetailService = async ({
  id,
}: {
  id: string;
}): Promise<GetApiResponse<AreaOfInterest[]>> => {
  try {
    const response = await api.get<GetApiResponse<AreaOfInterest[]>>(
      "/AreaOfInterest",
      {
        params: { id },
        headers: {
          ...(accessToken()
            ? { Authorization: `Bearer ${accessToken()}` }
            : {}),
        },
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const postAreaOfInterestService = async ({
  country,
  file,
  areaOfInterestName,
  idAttribute,
  nameAttribute,
}: {
  country: string;
  file: File[];
  areaOfInterestName: string;
  idAttribute: string;
  nameAttribute: string;
}): Promise<GetApiResponse<AreaOfInterest[]>> => {
  const formData = new FormData();

  formData.append("file", file[0]);
  formData.append("country", country);
  formData.append("areaOfInterestName", areaOfInterestName);
  formData.append("idAttribute", idAttribute);
  formData.append("nameAttribute", idAttribute); // TODO

  const response = await api.post<GetApiResponse<AreaOfInterest[]>>(
    "/AreaOfInterest/Upload",
    formData,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
        ...(accessToken() ? { Authorization: `Bearer ${accessToken()}` } : {}),
      },
    }
  );

  return response.data;
};

export const postAreaOfInterestPreviewService = async ({
  files,
}: {
  files: File[];
}): Promise<GetApiResponse<AreaOfInterestPreview>> => {
  try {
    const formData = new FormData();
    formData.append("file", files[0]);

    const response = await api.post<GetApiResponse<AreaOfInterestPreview>>(
      "/AreaOfInterest/Preview",
      formData,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
          ...(accessToken()
            ? { Authorization: `Bearer ${accessToken()}` }
            : {}),
        },
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteAreaOfInterestService = async ({
  id,
}: {
  id: string;
}): Promise<GetApiResponse<AreaOfInterest[]>> => {
  try {
    const response = await api.delete<GetApiResponse<AreaOfInterest[]>>(
      `/AreaOfInterest/${id}`,
      {
        headers: {
          ...(accessToken()
            ? { Authorization: `Bearer ${accessToken()}` }
            : {}),
        },
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};
